import { render, staticRenderFns } from "./iconBatteryPercent.vue?vue&type=template&id=3f8f0e36&"
import script from "./iconBatteryPercent.vue?vue&type=script&lang=js&"
export * from "./iconBatteryPercent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports